import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"fluid":""}},[_c(VRow,{staticClass:"px-sm-6 px-md-6 px-lg-10 px-xl-16",attrs:{"justify":_vm.$vuetify.breakpoint.xsOnly ? 'center' : 'start'}},[_c('a',{attrs:{"href":`/images/espa2022/poster_${_vm.$i18n.locale}.pdf`}},[_c(VCard,{staticClass:"pa-2 white",attrs:{"width":_vm.width,"rounded":"lg","flat":""}},[_c(VImg,{attrs:{"lazy-src":`/images/espa2022/ebanner_${_vm.$i18n.locale}.jpg`,"src":`/images/espa2022/ebanner_${_vm.$i18n.locale}.jpg`}})],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }